const VideoAsset = (props) => {
    const asset = props.asset;
    const assetStyles = props.assetStyles || "max-w-full object-cover mb-5";
    return (
        <video
            key={asset.id}
            className={assetStyles}
            alt={asset.alt_text}
            controls
            autoPlay
            muted
            loop
            playsInline
        >
            <source src={process.env.REACT_APP_ZVB_URL + "assets/" + asset.file + "?format=webp"} type="video/mp4"></source>
        </video>
    )
}

export default VideoAsset;